import * as React from 'react'

const AdditionalGalaDinnerForm = ({
  additionalGalaDinnerUserDetails,
  setAdditionalGalaDinnerUserDetails,
}) => {
  const showOtherField =
    additionalGalaDinnerUserDetails.dietary_restriction === 'Others'

  return (
    <div className="card">
      <div className="additional-gala-dinner-user-details p-3">
        <h6>
          Kindly complete the following information of the Additional Congress
          Dinner Attendee
        </h6>
        <div className="mb-2">
          <label>Full Name</label>
          <input
            type="text"
            className="form-control"
            value={additionalGalaDinnerUserDetails.full_name}
            onChange={(e) =>
              setAdditionalGalaDinnerUserDetails({
                ...additionalGalaDinnerUserDetails,
                full_name: e.target.value,
              })
            }
            required
          />
        </div>
        <div className="mb-2">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={additionalGalaDinnerUserDetails.email}
            onChange={(e) =>
              setAdditionalGalaDinnerUserDetails({
                ...additionalGalaDinnerUserDetails,
                email: e.target.value,
              })
            }
            required
          />
        </div>
        <div className="mb-2">
          <label>Phone</label>
          <input
            type="text"
            className="form-control"
            value={additionalGalaDinnerUserDetails.phone}
            onChange={(e) =>
              setAdditionalGalaDinnerUserDetails({
                ...additionalGalaDinnerUserDetails,
                phone: e.target.value,
              })
            }
            required
          />
        </div>
        <div className="mb-2">
          <label>
            Dietary Restriction*
            <br />
            <small className="text-muted">
              All food is Halal Certified, please do not select others and fill
              Halal.
              <br />
              More information on the gala dinner will be shared closer to the
              date of the Congress
            </small>
          </label>
          <select
            className="form-control"
            value={additionalGalaDinnerUserDetails.dietary_restriction}
            onChange={(e) =>
              setAdditionalGalaDinnerUserDetails({
                ...additionalGalaDinnerUserDetails,
                dietary_restriction: e.target.value,
                dietary_restriction_other:
                  e.target.value === 'Others'
                    ? additionalGalaDinnerUserDetails.dietary_restriction_other
                    : '',
              })
            }
            required
          >
            <option value="">Please Select</option>
            <option value="None">None</option>
            <option value="Vegetarian">Vegetarian</option>
            <option value="Vegan">Vegan</option>
            <option value="Gluten Free">Gluten Free</option>
            <option value="Seafood Allergy">Seafood Allergy</option>
            <option value="Others">Others</option>
          </select>
        </div>

        {showOtherField && (
          <div className="mb-2">
            <label>Other Dietary Restriction*</label>
            <input
              type="text"
              className="form-control"
              value={
                additionalGalaDinnerUserDetails.dietary_restriction_other || ''
              }
              onChange={(e) =>
                setAdditionalGalaDinnerUserDetails({
                  ...additionalGalaDinnerUserDetails,
                  dietary_restriction_other: e.target.value,
                })
              }
              placeholder="Please specify your dietary restriction"
              required
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default AdditionalGalaDinnerForm
